import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Fractional star rating rendered with two layered rows (no emoji, no images):
// a grey base row of ★ and a gold row clipped to the average's width.
const Wrap = styled.span`
  position: relative;
  display: inline-block;
  font-size: ${(p) => p.size}px;
  line-height: 1;
  letter-spacing: 1px;
  vertical-align: middle;
  font-family: Arial, sans-serif;
`;
const Base = styled.span`
  color: #d7dde0;
`;
const Fill = styled.span`
  color: #f5a623;
  position: absolute;
  top: 0;
  left: 0;
  width: ${(p) => p.pct}%;
  overflow: hidden;
  white-space: nowrap;
`;

const Stars = ({ value = 0, size = 13 }) => {
  const pct = Math.max(0, Math.min(100, (Number(value) / 5) * 100));
  return (
    <Wrap size={size} aria-label={`${Number(value).toFixed(1)} out of 5`}>
      <Base>★★★★★</Base>
      <Fill pct={pct}>★★★★★</Fill>
    </Wrap>
  );
};

Stars.propTypes = { value: PropTypes.number, size: PropTypes.number };

export default Stars;
